import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  IconButton,
  Button,
  Paper,
  Avatar
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import CheckIcon from '@mui/icons-material/Check';

const languages = [
  { code: "en", label: "English", flagCode: "gb" },
  { code: "de", label: "Deutsch", flagCode: "de" },
];

const LanguageOverlay = ({ open, onClose }) => {
  const { i18n, t } = useTranslation();
  const [selectedLang, setSelectedLang] = useState(i18n.language);

  const handleLanguageChange = (code) => {
    setSelectedLang(code);
    i18n.changeLanguage(code); // Change language immediately on selection
  };

  useEffect(() => {
    setSelectedLang(i18n.language);
  }, [i18n.language]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <Box sx={{ padding: "16px" }}>
        <DialogTitle sx={{ position: "relative", padding: "10px 16px 0", marginBottom: "12px" }}>
          <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "18px", textAlign: "center" }}>
            {t("Language Selection")}
          </Typography>
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 0,
              top: 0,
              color: "rgba(0, 0, 0, 0.54)",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ padding: "0 16px" }}>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 300,
              color: "#475467",
              textAlign: "center",
              marginBottom: 2,
            }}
          >
            {t("Please select which language you would like to use to fill the form with.")}
          </Typography>

          {languages.map(({ code, label, flagCode }) => {
            const isSelected = selectedLang === code;

            return (
              <Paper
                key={code}
                onClick={() => handleLanguageChange(code)}
                elevation={0}
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  border: isSelected ? "2px solid #66C7D1" : "1px solid #dbdbdb",
                  borderRadius: "8px",
                  padding: "12px 16px",
                  marginBottom: 2,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Avatar
                    src={`https://flagcdn.com/w40/${flagCode}.png`}
                    alt={label}
                    sx={{ width: 32, height: 32 }}
                  />
                  <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>{label}</Typography>
                </Box>
                {isSelected && (
                  <CheckIcon sx={{ color: "#66C7D1", fontSize: 24 }} />
                )}
              </Paper>
            );
          })}
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", padding: "16px" }}>
          <Button
            variant="contained"
            onClick={onClose}
            fullWidth
            sx={{
              background: "#2F37B5",
              color: "#fff",
              fontWeight: 600,
              fontSize: "16px",
              height: "48px",
              borderRadius: "8px",
              textTransform: "none",
              "&:hover": {
                background: "#1f2fa0",
              },
            }}
          >
            {t("Continue")}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default LanguageOverlay;
